import { ActionTypes } from "../constants/action-types";

export const setEmails = (emails) => {
	return {
		type: ActionTypes.SET_EMAILS,
		payload: emails,
	};
};
